<template>
    <div>
       <!--<p style="font-size: 14px; margin: 0; margin-bottom: 15px;">Поиск по:</p>--> 
       <!-- Табы -->
        <ul class="nav nav-tabs nav-justified">
          <!--<li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('cakt-search-main')" :class="{ active: isActive('cakt-search-main') }" href="#cakt-search-main">Децимальному номеру</a>
          </li>-->
          <!--<li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('release-search')" :class="{ active: isActive('release-search') }" href="#release-search">Release</a>
          </li>-->
           <!--<li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('test-search')" :class="{ active: isActive('test-search') }" href="#test-search">Тест</a>
          </li>-->
          <!--РАБОТАЮЩИЕ
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('cakt-search')" :class="{ active: isActive('cakt-search') }" href="#cakt-search">Децимальному номеру</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('name-search')" :class="{ active: isActive('name-search') }" href="#name-search">Наименованию</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('serial-search')" :class="{ active: isActive('serial-search') }" href="#serial-search">Серийному номеру</a>
          </li>-->
        </ul>

        <div class="tab-content py-3" id="myTabContent">

          <!--<div class="tab-pane fade" :class="{ 'active show': isActive('cakt-search-main') }" id="cakt-search-main">
            <CaktSearch />
          </div>-->

          <!--<div class="tab-pane fade" :class="{ 'active show': isActive('release-search') }" id="release-search">
            <Release />
          </div>-->

          <!--<div class="tab-pane fade" :class="{ 'active show': isActive('test-search') }" id="test-search">
            <Test />
          </div>-->

          <!--РАБОТАЮЩИЕ
          <div class="tab-pane fade" :class="{ 'active show': isActive('cakt-search') }" id="cakt-search">
            <CaktDocs />
          </div>

          <div class="tab-pane fade" :class="{ 'active show': isActive('name-search') }" id="name-search">
            <NameDocs />
          </div>

          <div class="tab-pane fade" :class="{ 'active show': isActive('serial-search') }" id="serial-search">
            <SerialDocs />
          </div>-->
          
          <div class="tab-pane fade" :class="{ 'active show': isActive('serial-search') }" id="serial-search">
            <SerialDocs />
          </div>

        </div>
       <!-- / Табы -->

    </div>
</template>

<script>
import SerialDocs from '@/components/SerialDocs2.vue'
//import CaktDocs from '@/components/CaktDocs.vue'
//import NameDocs from '@/components/NameDocs.vue'
//import Test from '@/components/Test.vue'
//import Release from '@/components/Release/Release.vue'
//import CaktSearch from '@/components/CaktSearch/CaktSearch.vue'

export default {
  name: 'TechDocs',
  components: {
    SerialDocs,
    //CaktDocs,
    //NameDocs,
    //Test,
    //Release,
    //CaktSearch
  },
  data() {
    return {
      activeItem: 'serial-search'
    }
  },
  methods: {
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem;
      this.user_input = ''
    }
	}
}
</script>

<style lang="sass">
*, *::before, *::after
  box-sizing: border-box
.nav
  &-tabs
    display: flex
    @media screen and (max-width: 375.9px)
        flex-direction: column
    @media screen and (min-width: 376px)
        flex-flow: row wrap
  &-item
    margin-right: 15px
    margin-bottom: 25px
  &-link
    border: 1px solid
    border-radius: 25px
    padding: 8px 16px
    font-size: 11px
    &.active
      font-weight: 400
      background-color: #012786a6
      color: #fff
      border: none
      box-shadow: 0 6px 10px rgba(129, 147, 186, 0.26)
.tab
  &-content
  &-pane
    display: none
    &.active
      display: block

ul
  list-style: none
  margin: 0
  padding: 0
.docs
  display: flex
  flex-direction: column
  margin-bottom: 20px
  &__title
    margin-bottom: 25px
  &-search
    margin-bottom: 40px
    div
      display: flex
      @media screen and (max-width: 560px)
        width: 100%
      @media screen and (min-width: 561px)
        width: 400px
    &__input
      width: 100%
      padding: 10px 10px
      font-size: 12px
      color: #272727
      font-weight: 400
      border: 1px solid #01278621
      border-right: 0
    &__button
      padding: 9px 15px
    &__small 
      font-size: 12px
      font-weight: 400
      span
        font-weight: 800
    &-form
      button
        
        background-color: #ffffff
        color: #5a72b0
        border: 1px solid #5a72b0
        cursor: pointer
        transition: 0.5s
        font-size: 12px
        font-family: inherit
  &__name
    margin-bottom: 10px
    font-weight: 300
    font-size: 14px
    line-height: 1.4
  &__fullname
    font-weight: 700
    font-size: 15px
    line-height: 1.4
  &__cakt
    margin-bottom: 15px
    font-size: 11px
    font-weight: 400
  &__link
    border: 1px solid #8193ba
    text-align: center
    font-family: inherit
    font-size: 11px
    padding: 7px 10px
    color: #202c45
    cursor: pointer
    border-radius: 5px
    box-shadow: 0 8px 15px rgba(129, 147, 186, 0.26)
    transition: 0.5s
    &:hover
     background-color: #8193ba
     color: #ffffff
.t-docs
    margin-top: 10px
    margin-left: 15px
    &__item
      display: flex
      padding: 15px 0 25px
    &__image
      margin-right: 10px
      img
        width: 75px
        height: auto
    &__name
      font-size: 14px
      margin-bottom: 10px
      a
        font-weight: 500
        text-decoration: underline
    &__description,
    &__cakt
      font-size: 13px
</style>